<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
        > 
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br/><br/>
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">{{ title }}</div>
        <div v-if="existeContactoBce!=false">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert
              prominent
              type="info"
            >
            Tiene una reunión para inscripción a materias el día {{ contactoBce.fecha_atencion}} a las {{contactoBce.hora_atencion }} con {{ ((contactoBce.usuario)?contactoBce.usuario.usu_nombre:'') }}
            </v-alert>
          </v-col>
        </div>
        <div v-else-if="user.excedente">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert
              prominent
              type="info"
            >
              No es posible inscribirse a cursar materias porque estamos fuera del período de inscripción
            </v-alert>
          </v-col>
        </div>
        <div v-else>
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12"
             v-if="materias.cantidad == 0"
            >
            <v-alert
              prominent
              type="info"
            >
              En este momento no hay inscripciones abiertas a materias
            </v-alert>
          </v-col>
          <div
            v-frag
            v-for="(examenMesa, examenMesaKey) in materias.data"
            :key="examenMesaKey"
          >
            <v-card elevation="0">
              <v-card-text
                >Cantidad de materia disponibles :
                {{ examenMesa.cantidad }}</v-card-text
              >
            </v-card>

            <div
              class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text"
            >
              {{ examenMesa.curso.Feriado }}
            </div>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Examen
                    </th>
                    <th class="text-left">
                      Accion
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(planDeEstudioData,
                    planDeEstudioDataKey) in examenMesa.curso
                      .plan_de_estudio_v2"
                    :key="planDeEstudioDataKey"
                  >
                    <td>{{ planDeEstudioData.Materia }}</td>
                    <td>
                      <div v-frag v-if="planDeEstudioData.tipo == 0">
                        <v-btn
                          @click="() => null"
                          class="grey--text font-weight-regular"
                          depressed
                          text
                          disabled
                          color="grey"
                          >Sin Mesa Aún</v-btn
                        >
                      </div>
                      <div v-frag v-if="planDeEstudioData.tipo == 1">
                        <v-btn
                          @click="
                            inscripcionMesaMateria(
                              planDeEstudioData.IDStB,
                              examenMesa.id
                            )
                          "
                          depressed
                          text
                          color="Colorsuccess"
                          >Inscribir</v-btn
                        >
                      </div>
                      <div v-frag v-if="planDeEstudioData.tipo == 2">
                        <v-alert color="info">
                          Esperando confirmacion
                          <v-btn
                            @click="
                              cancelarInscripcionMesaMateria(
                                planDeEstudioData
                                  .materia_inscipcion_alumno[0]
                                  .id_validacion
                              )
                            "
                            small
                            class="red--text text-decoration-underline font-weight-regular"
                            depressed
                            text
                            color="red"
                            >Cancelar</v-btn
                          >
                        </v-alert>
                      </div>
                      <div v-frag v-if="planDeEstudioData.tipo == 3">
                        <v-btn
                          @click="() => null"
                          depressed
                          text
                          color="Colorsuccess"
                          >Inscripto</v-btn
                        >
                      </div>
                      <div v-frag v-if="planDeEstudioData.tipo == 5">
                        <v-alert color="info">
                          Inscripto
                          <v-btn
                            @click="
                              cancelarInscripcionMesaMateria(
                                planDeEstudioData
                                  .materia_inscipcion_alumno[0]
                                  .id_validacion
                              )
                            "
                            small
                            class="red--text text-decoration-underline font-weight-regular"
                            depressed
                            text
                            color="red"
                            >Cancelar</v-btn
                          >
                        </v-alert>
                      </div>
                      <div v-frag v-if="planDeEstudioData.tipo == 4">
                        <v-alert type="error">
                          Rechazado
                        </v-alert>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <br/><br/>
        </div>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Nota",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    
  },

  data: () => ({
    title:"Tus inscripciones a materias",
    materias:[],  
    existeContactoBce:false,
    contactoBce:null
  }),
  methods:{
    async inscripcionMesaMateria(examen, mesa) {
      await this.$API
        .post({
          url: "materia/mesas-inscripcion",
          data: {
            materia_id: examen,
            examenMesa_id: mesa
          }
        })
        .then(() => {
          this.mesaDeMateria();
        });
    },
    async cancelarInscripcionMesaMateria(id) {
      await this.$API
        .post({
          url: "materia/cancelar-inscripcion",
          data: {
            id: id
          }
        })
        .then(() => {
          this.mesaDeMateria();
        });
    },
    async mesaDeMateria() {
      await this.$API
        .get({
          url: "materia/mesas",
          data: {}
        })
        .then(res => {
          this.materias = res;
        });
    },
    async obtenerContacto(){
      await this.$API
        .post({
          url: "contacto-bce/obtener-contacto",
          data: {
            alumno: this.user.IDStB,
          },
        })
        .then((res)=>{
          this.existeContactoBce=res.existe
          this.contactoBce=res.contacto
        })
    }
  },

  mounted() {
    if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true){
      this.$router.push({
          name: "Home"
        });
    }
    this.$API
      .get({
        url: "materia/mesas",
        data: {}
      })
      .then(res => {
        this.materias = res;
      });

      this.obtenerContacto()
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
};
</script>
